import {Link as GatsbyLink} from "gatsby"
import React from "react"
import styled from "styled-components"

const Link = (props) => {
  const linkRendered = <GatsbyLink to={`/${props.to}`}>{props.children}</GatsbyLink>

  if (props.block) {
    return <OuterDiv>{linkRendered}</OuterDiv>
  }

  return linkRendered
}

const OuterDiv = styled.div`
  a {
    display: block;
    text-decoration: none;
  }
`

Link.defaultProps = {
  block: false,
}

export {Link}
